import { render } from "./TopMessage.vue?vue&type=template&id=3f7e190d&scoped=true"
import script from "./TopMessage.vue?vue&type=script&lang=js"
export * from "./TopMessage.vue?vue&type=script&lang=js"

import "./TopMessage.vue?vue&type=style&index=0&id=3f7e190d&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7e190d"]])

export default __exports__